import type { Archetype } from '../../content/routes';
import type { Rng } from '../../core/rng';
import type { BuildingLook } from './building';
import { variantCount } from './facadeLibrary';

export interface Plan {
  look: BuildingLook;
  /** Distance from the building line back to the facade. */
  setback: number;
  /** Compounds: a wall on the building line with a villa behind it. */
  compound: boolean;
  /** Umbrellas and hawkers in front. */
  market: boolean;
  tanks: number;
}

const ROOFS = { concrete: '#8f8a80', blueSheet: '#2f6fb0', redSheet: '#a4442b', tealSheet: '#2a8c8c', dark: '#4a4d52' };

function pickVariant(rng: Rng, kind: BuildingLook['upper']): number {
  return rng.int(0, variantCount(kind) - 1);
}

export function planBuilding(kind: Archetype, width: number, rng: Rng): Plan {
  switch (kind) {
    case 'shophouse':
      return {
        look: { upper: 'shophouse', ground: 'shopfront', variant: pickVariant(rng, 'shophouse'), groundVariant: pickVariant(rng, 'shopfront'), floors: rng.int(1, 3), width, depth: rng.range(9, 13), groundHeight: 3.6, roof: rng.next() > 0.7 ? ROOFS.blueSheet : ROOFS.concrete },
        setback: 0, compound: false, market: false, tanks: rng.int(0, 2),
      };
    case 'market':
      return {
        look: { upper: 'shophouse', ground: 'shopfront', variant: pickVariant(rng, 'shophouse'), groundVariant: pickVariant(rng, 'shopfront'), floors: rng.int(0, 2), width, depth: rng.range(12, 20), groundHeight: 3.8, roof: rng.pick([ROOFS.blueSheet, ROOFS.tealSheet, ROOFS.redSheet]) },
        setback: 0, compound: false, market: true, tanks: rng.int(0, 1),
      };
    case 'office':
      return {
        look: { upper: 'concrete', ground: 'glass', variant: pickVariant(rng, 'concrete'), groundVariant: pickVariant(rng, 'glass'), floors: rng.int(3, 8), width, depth: rng.range(14, 20), groundHeight: 4.4, roof: ROOFS.concrete },
        setback: rng.range(2, 6), compound: false, market: false, tanks: rng.int(1, 3),
      };
    case 'tower':
      return {
        look: { upper: 'glass', ground: 'concrete', variant: pickVariant(rng, 'glass'), groundVariant: pickVariant(rng, 'concrete'), floors: rng.int(8, 18), width, depth: rng.range(16, 22), groundHeight: 5, roof: ROOFS.dark },
        setback: rng.range(5, 10), compound: false, market: false, tanks: 0,
      };
    case 'compound':
      return {
        look: { upper: 'concrete', ground: 'wall', variant: pickVariant(rng, 'concrete'), groundVariant: pickVariant(rng, 'wall'), floors: rng.int(1, 2), width, depth: rng.range(10, 14), groundHeight: 2.6, roof: rng.pick([ROOFS.redSheet, ROOFS.concrete, ROOFS.dark]) },
        setback: rng.range(7, 10), compound: true, market: false, tanks: rng.int(0, 1),
      };
  }
}
